export const MENU_LIST = {
  MY_ACCOUNT: 'Tài khoản của tôi',
  MANAGE_ADDRESS: 'Quản lý địa chỉ',
  ORDER: 'Đơn hàng',
  INTEREST_PRODUCT: 'Sản phẩm yêu thích',
  NOTIFICATION: 'Thông báo',
};
